import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { clearAdvisorDetailInfo, fetchAdvisorDetailsData, getAdvisorSinglePageDetails } from '../../../store/slices/catalogSlice';
import { capitalizeFirstLetter } from '../../../utils/helper';
import SingleLanding from '../SingleLanding';

const AdvisorLanding = () => {
    const { advisorAlias } = useParams();
    const { loading, data: advisor, error } = useSelector(getAdvisorSinglePageDetails);
    const iconPath = advisor?.images.title;

    const dispatch = useDispatch();

    const altText = capitalizeFirstLetter(advisorAlias);

    useEffect(() => {
        dispatch(fetchAdvisorDetailsData(advisorAlias));
    }, [advisorAlias, dispatch]);

    useEffect(() => {
        return () => {
            dispatch(clearAdvisorDetailInfo());
        };
    }, []);

    return (
        <>
            <SingleLanding
                loading={loading}
                advisor={advisor}
                iconPath={iconPath}
                altText={altText}
                error={error}
                title={advisor?.strings.title}
                subtitle={advisor?.strings.subtitle}
                advisorAlias={advisorAlias}
            />
        </>
    );
};

export default AdvisorLanding;
